
//スマホ用に移動
const MatrixCartArea = document.querySelector(".matrix_area");
const SpMatrixCartArea = document.querySelector(".sp_cartbtn_box");

if (window.innerWidth <= 640) {
  SpMatrixCartArea.appendChild(MatrixCartArea);
}

//カートオープン
const CartOpenBtn = document.querySelector(".sp_fixed_cartbtn");
const CartCloseBtns = document.querySelectorAll(".cart_close_btn");
const CartOpenArea = document.querySelector(".sp_cartbtn_area");
const body =document.querySelector("body");

CartOpenBtn.addEventListener("click",function(){
  body.classList.add("overflow-hidden-cart-modal");
});

CartCloseBtns.forEach(btn => {
  btn.addEventListener("click",function(){
    body.classList.remove("overflow-hidden-cart-modal");
  });
});